import React, { useRef, useEffect } from 'react';
import { TweenLite } from 'gsap';

interface ParticleProps {
    key: any;
    duration: number;
    ease: any;
    startPos: number;
    endPos: number;
    css: any;
}

export const Particle: React.FC<ParticleProps> = ({
    duration,
    ease,
    startPos,
    endPos,
    css,
}: {
    duration: number;
    ease: any;
    startPos: number;
    endPos: number;
    css: any;
}) => {
    let particle: any = useRef(null);

    useEffect(() => {
        console.log('POS: ', [startPos, endPos]);

        TweenLite.fromTo(
            particle,
            duration,
            { y: startPos },
            { y: endPos, ease: ease, repeat: -1 }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [particle]);

    return (
        <div
            ref={(par) => {
                particle = par;
            }}
            style={css}
        />
    );
};

/*export const Particles: React.FC<ParticleHeadProps[]> = (props?: ParticleHeadProps[]) => {
    return (
        <div className={styles.particles}>
            {props &&
                props!.length > 0 &&
                props!.map((particle: any, index: number) => (
                    <Particle key={index} props={particle} />
                ))}
        </div>
    );
};*/
